<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="notification-content">
    <v-menu offset-y :close-on-content-click="false" dark>
      <template v-slot:activator="{ on }">
        <v-badge overlap offset-x="12" :color="countNew > 0 ? 'red' : 'transparent'">
          <template v-slot:badge>
            <div>{{ countNew >= 99 ? '99+' : countNew }}</div>
          </template>
          <v-hover v-slot:default="{ hover }">
            <v-btn style="min-width: 0; width: 36px; min-height: 0; height: 36px" large icon v-on="on"
              @click="seeAllNotifi">
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </v-hover>
        </v-badge>
      </template>
      <v-card width="529px">
        <v-responsive class="overflow-y-auto" max-height="400" max-width="529px">
          <v-layout column>
            <v-card-title class="py-2 px-4">
              <span class="title">
                Notifications
              </span>
              <v-spacer />
              <v-hover v-slot:default="{ hover }">
                <span @click="readAllNotifi" :disabled="checkDisable" v-bind:style="{ 'color': hover ? '#2591F4' : '' }"
                  style="cursor: pointer; font-weight: 550; font-size: 14px; text-decoration-line: underline">
                  Mark all as read
                </span>
              </v-hover>
              <v-hover class="ml-2" v-slot:default="{ hover }">
                <router-link :to="link" v-bind:style="{ 'color': hover ? '#2591F4 !important' : '' }"
                  style="font-weight: 550; font-size: 14px; text-decoration-line: underline">
                  Show all activities
                </router-link>
              </v-hover>
            </v-card-title>
            <v-list class="pa-2" style="overflow-y: auto" v-if="notifications && notifications.length > 0" two-line
              subheader>
              <template v-for="item in notifications">
                <v-divider></v-divider>

                <v-list-item :key="item.title" :title="item.data.title" @click="clickNoti">
                  <v-list-item-content @click="gotoDetail(item)">
                    <v-list-item-title>
                      <v-layout>
                        <div style="width: 78px; height: 22px; text-align: center; border-radius: 4px"
                          v-bind:style="{ 'background-color': renderColor(item.output) }">
                          {{ item.output }}
                        </div>
                        <span class="ml-3">{{ item.workspace ? item.workspace.name : '' }}</span>
                      </v-layout>
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-2">
                      <div class="d-flex align-items-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="10" cy="9.99984" r="8.33333" stroke="#2FE37B" stroke-width="1.5" />
                          <path d="M14.1667 7.5L8.4375 13.3333L5.83333 10.6818" stroke="#2FE37B" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg> 
                        <span class="ml-3 text-truncate" style="line-height: 24px; max-width: 400px;"
                          :title="item.data.message">{{ item.data.message }}</span>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action class="pt-1 pb-1">
                    <v-list-item-action-text>
                      <v-layout>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.99998 14.6668C11.6819 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6819 1.3335 7.99998 1.3335C4.31808 1.3335 1.33331 4.31826 1.33331 8.00016C1.33331 11.6821 4.31808 14.6668 7.99998 14.6668Z"
                            stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M8 4V8L10.6667 9.33333" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                        <span class="ml-2">{{ calculateTime(item.updated_at) }}</span>
                      </v-layout>
                    </v-list-item-action-text>
                    <v-btn text color="accent"
                      style="font-weight: normal;font-size: 14px;; text-transform: none; min-width: 50px" class="px-0"
                      @click="showInfo(item)">Show</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </template>

            </v-list>
            <div v-else style="padding: 10px">Empty</div>
          </v-layout>
        </v-responsive>
      </v-card>
    </v-menu>
    <Detail ref="detailNotification" @gotoDetail="gotoDetail"></Detail>
  </div>
</template>

<script>
// import api from '@/api'
import MENU from '@/constants/menu-constants'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Detail from './detail-notification'
import config from '@/config'

export default {
  name: 'Notification',
  data() {
    return {
      dialog: false,
      currentNotification: undefined,
      loading: false,
      appPath: config.app_path
    }
  },
  components: {
    Detail
  },
  watch: {
  },
  created() {
    if (this.userProfile && this.loggedIn && this.userProfile.region) {
      this.fetchNotification()
    }
  },
  computed: {
    ...mapGetters('workspace', ['workspaces']),
    ...mapGetters('auth', ['loggedIn', 'userProfile']),
    ...mapGetters('notification', ['notifications', 'countNew']),
    checkDisable() {
      let read = this.notifications.filter(val => val.status !== 1).length
      if (read > 0) return false
      return true
    },
    link() {
      if (this.$route.params.id) return `/activity/${this.$route.params.id}`
      return this.workspaces.length ? `/activity/${this.workspaces[0].id}` : ''
    }
  },
  methods: {
    ...mapActions('notification', ['fetchNotification', 'markRead', 'seeAll', 'readAll']),
    ...mapActions('workspace', ['fetchWorkspace']),
    clickNoti() { },
    checkWorkspaceExits() {
      let check = true
      let workspaceId = this.currentNotification.workspace_id
      if (!workspaceId) {
        check = false
      } else {
        let workspace = this.workspaces.find(val => val.id === workspaceId)
        if (workspace) {
          check = true
        } else {
          check = false
          this.$snackbar.showError("Workspace doesn't exists")
        }
      }
      return check
    },
    async gotoDetail(currentNotification) {
      await this.fetchWorkspace()
      this.currentNotification = currentNotification
      this.markRead(currentNotification).then(res => {
        switch (currentNotification.output) {
          case 'task': return
          case 'model': {
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.MODELS : MENU.TASKS }
              })
            }
            break
          }
          case 'image':
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'vector':
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.VECTORS : MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'table':
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.TABLE : MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'mosprep':
            if (this.checkWorkspaceExits()) {
              this.$router.push({ name: `mosaic` })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'share':
            switch (currentNotification.type) {
              case 'share_result':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.RESULTS : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.RESULTS : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_vector':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.VECTORS : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.VECTORS : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_image':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_model':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.MODELS : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.MODELS : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_model_folder':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.MODELS : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.MODELS : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_image_folder':
                localStorage.setItem('tab', 'share')
                if (this.workspaces.length) {
                  if (this.$route.params.id) {
                    this.$router.push({
                      path: `/workspaces/${this.$route.params.id}/`,
                      query: { menu: currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS }
                    })
                  } else {
                    const menu = currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS
                    window.location = `${this.appPath}/workspaces/${this.workspaces[0].id}?menu=${menu}`
                  }
                } else {
                  this.$snackbar.showError('Please, Create new a workspace !!')
                }
                break
              case 'share_workspace':
                if (this.checkWorkspaceExits()) {
                  localStorage.setItem('tab', 'share')
                  this.$router.push({
                    path: `/workspaces/${currentNotification.workspace_id}/`,
                    query: { menu: currentNotification.is_success ? MENU.MAPS : MENU.TASKS }
                  })
                }
                break
            }
            break
          case 'pipeline':
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.WORKFLOW : MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'result':
            if (this.checkWorkspaceExits()) {
              let menu = MENU.TASKS
              if (currentNotification.is_success && currentNotification.data && currentNotification.data.type) {
                const taskType = currentNotification.data.type
                
                // Vector output tools
                const vectorTools = [
                  'raster_to_vector',
                  'rectify'
                ]
                
                // Image output tools
                const imageTools = [
                  'morphology',
                  'raster_to_image',
                  'reclassification',
                  'nvdi',
                  'crop_scout',
                  'upload_result'
                ]
                
                // Predict tools that output vector
                const predictVectorTools = [
                  'predict_palm_tree',
                  'predict_tree_counting',
                  'predict_tree_counting_2m_uav',
                  'predict_tree_counting_40d_uav',
                  'predict_dead_tree_counting_uav',
                  'predict_building_footprint',
                  'predict_car_counting_nunukan',
                  'predict_mongkos_treecouting'
                ]
                
                // Predict tools that output image
                const predictImageTools = [
                  'predict_buildup_area',
                  'predict_road_detection',
                  'predict_water_detection',
                  'predict_change_detection',
                  'predict_deforestation',
                  'predict_change_detection_sar'
                ]
                
                if (vectorTools.includes(taskType) || predictVectorTools.includes(taskType)) {
                  menu = MENU.VECTORS
                } else if (imageTools.includes(taskType) || predictImageTools.includes(taskType)) {
                  menu = MENU.IMAGERY
                } else if (taskType.startsWith('private_') || taskType.startsWith('predict_')) {
                  // For other predict/private tools, default to IMAGERY
                  // (most models output image, vector models are handled above)
                  menu = MENU.IMAGERY
                }
              }
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          case 'folder':
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: currentNotification.is_success ? MENU.IMAGERY : MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
          default:
            if (this.checkWorkspaceExits()) {
              this.$router.push({
                path: `/workspaces/${currentNotification.workspace_id}/`,
                query: { menu: MENU.TASKS }
              })
            } else {
              this.$snackbar.showError("Workspace doesn't exists")
            }
            break
        }
      }).catch(er => {
        this.$snackbar.showError(er.message)
      })
    },
    showInfo(noti) {
      this.currentNotification = noti
      this.markAsRead(noti)
      this.$refs.detailNotification.openDialog(noti)
    },
    renderColor(output) {
      switch (output) {
        case 'task': return '#17DF6C'
        case 'model': return '#2591F4'
        case 'image': return '#F2C94C'
        case 'share': return '#47C8F0'
        case 'pipeline': return '#47C8F0'
        case 'result': return '#BC67FF'
        case 'folder': return '#00d6c1'
        case 'vector': return '#a8eb34'
        case 'mosprep': return '#5a097c'
        case 'train_v2': return '#2196f3'
        default: return '#000000'
      }
    },
    calculateTime(utcStr) {
      let duration = moment.duration(moment().diff(moment.parseZone(utcStr)))
      if (duration.asDays() > 10) {
        return moment(utcStr).format('DD MMM')
      } else if (duration.asDays() > 1) {
        let day = parseInt(duration.asDays(), 10)
        return `${day}d`
      } else if (duration.asHours() > 1) {
        let hour = parseInt(duration.asHours(), 10)
        return `${hour}h `
      } else if (duration.asMinutes() > 1) {
        let min = parseInt(duration.asMinutes(), 10)
        return `${min}m`
      } else {
        return 'now'
      }
    },
    markAsRead(item) {
      this.markRead(item)
    },
    seeAllNotifi() {
      this.seeAll()
    },
    readAllNotifi() {
      this.readAll()
    }
  }
}
</script>
<style lang="css" scoped>
.notification-content {
  max-height: 300px;
}
</style>
<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/notification/notification.vue